import React, { Component } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { graphql, useStaticQuery } from 'gatsby'
import CtaArrow from '../../../components/ctaArrow'
import {
  googleTrackingTag,
  qpGenLead,
  bingEvent
} from '../../../utils/thirdPartyUtils'
import './styles.scss'

const validator = {
  isLength: (str, min, max) => str.length >= min && (typeof max === 'undefined' || str.length <= max),
  isEmail: (str) =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      String(str).toLowerCase()
    )
}

const recaptchaRef = React.createRef()

class Signup extends Component {
  state = {
    username: '',
    firstName: '',
    lastName: '',
    organization: '',
    password: '',
    passwordError: '',
    emailError: '',
    formError: '',
    firstNameError: '',
    lastNameError: '',
    organizationError: '',
    isValidEmail: false,
    isValidPassword: false,
    isValidFirstName: '',
    isValidLastName: '',
    isValidOrganization: '',
    customReferer: typeof window !== 'undefined' ? window.location.href : '',
    captcha: null
  }

  render() {
    const { googleCaptchaSiteKey } = this.props
    const { username, firstName, lastName, organization, emailError, formError, password, passwordError, isValidEmail, isValidPassword, firstNameError, lastNameError, organizationError, isValidFirstName, isValidLastName, isValidOrganization } = this.state
    return (
      <form className="u-margintop-medium" id="signup-form" onSubmit={this.handleSubmit}>
        <div style={{ color: 'red' }}>{formError}</div>
        <div className="field field-group-email">
          <div className="sign-up-label">First Name</div>
          <input
            className="input is-large is-subtle"
            placeholder="First Name"
            type="text"
            name="firstName"
            onChange={this.handleInputChange}
            value={firstName}
          />
          <div id="signup-form-error-firstName" className="signup-form-error">
            {firstNameError}
          </div>
        </div>
        <div className="field field-group-email">
          <div className="sign-up-label">Last Name</div>
          <input
            className="input is-large is-subtle"
            placeholder="Last Name"
            type="text"
            name="lastName"
            onChange={this.handleInputChange}
            value={lastName}
          />
          <div id="signup-form-error-lastName" className="signup-form-error">
            {lastNameError}
          </div>
        </div>
        <div className="field field-group-email">
          <div className="sign-up-label">Email address</div>
          <input
            className="input is-large is-subtle"
            placeholder="Work Email Address"
            type="email"
            name="username"
            onChange={this.handleInputChange}
            value={username}
          />
          <div id="signup-form-error-email" className="signup-form-error">
            {emailError}
          </div>
        </div>
        <div className="field field-group-email">
          <div className="sign-up-label">Organization</div>
          <input
            className="input is-large is-subtle"
            placeholder="Company name"
            type="text"
            name="organization"
            onChange={this.handleInputChange}
            value={organization}
          />
          <div id="signup-form-error-organization" className="signup-form-error">
            {organizationError}
          </div>
        </div>
        <div className="field field-group-password">
          <div className="sign-up-label password">Password</div>
          <input
            onChange={this.handleInputChange}
            className="input is-large is-subtle"
            type="password"
            name="password"
            placeholder="Password"
            value={password}
          />
          <div id="signup-form-error-password" className="signup-form-error">
            {passwordError}
          </div>
        </div>
        <div className="control u-margintop-medium">
          <button
            className="button is-primary is-large"
            id="start-trial-button"
            type="submit"
            disabled={!isValidEmail || !isValidPassword || !isValidFirstName || !isValidLastName || !isValidOrganization}
          >
            Start my trial now
            <CtaArrow />
          </button>
        </div>
        <p className="help u-margintop-medium">
          By clicking "Start My Trial Now", you agree to LaunchDarkly's{' '}
          <a href="/policies/terms-of-service/" target="_blank" rel="noopener noreferrer">
            Terms
          </a>{' '}
          and{' '}
          <a href="/policies/privacy/" target="_blank" rel="noopener noreferrer">
            Privacy Policies
          </a>
          .
        </p>
        <ReCAPTCHA
          sitekey={googleCaptchaSiteKey}
          ref={recaptchaRef}
          size="invisible"
          onChange={this.handleCaptchaChange}
        />
      </form>
    )
  }

  handleCaptchaChange = (value) => {
    this.setState({ captcha: value })
    this.createAccount()
  }

  handleInputChange = (event) => {
    const { target } = event
    const { name } = target

    if (name === 'username') {
      this.validateEmail(target.value)
    } else if (name === 'password') {
      this.validatePassword(target.value)
    } else if (name === 'firstName') {
      this.validateFirstName(target.value)
    } else if (name === 'lastName') {
      this.validateLastName(target.value)
    } else if (name === 'organization') {
      this.validateOrganization(target.value)
    }

    this.setState({
      [name]: target.value
    })
  }

  validateEmail = (email) => {
    if (!email.trim().length) {
      this.setState({
        emailError: 'Email is a required field',
        isValidEmail: false
      })
    } else if (!validator.isEmail(email)) {
      this.setState({
        emailError: 'Email address is invalid',
        isValidEmail: false
      })
    } else if (email) {
      this.setState({
        emailError: '',
        isValidEmail: true
      })
    } else {
      this.setState({
        isValidEmail: false
      })
    }
  }

  validatePassword = (password) => {
    if (!password.trim().length) {
      this.setState({
        isValidPassword: false
      })
    } else if (!validator.isLength(password, 8)) {
      this.setState({
        passwordError: `Password must be at least 8 characters long and contain at least 3 of the following: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character`,
        isValidPassword: false
      })
    } else if (password) {
      this.setState({
        passwordError: '',
        isValidPassword: true
      })
    } else {
      this.setState({
        isValidPassword: false
      })
    }
  }

  validateFirstName = (input) => {
    if (input === '') {
      this.setState({
        firstNameError: 'First name is required',
        isValidFirstName: false
      })
    } else if (input) {
      this.setState({
        firstNameError: '',
        isValidFirstName: true
      })
    } else {
      this.setState({
        isValidFirstName: false
      })
    }
  }

  validateLastName = (input) => {
    if (input === '') {
      this.setState({
        lastNameError: 'Last name is required',
        isValidLastName: false
      })
    } else if (input) {
      this.setState({
        lastNameError: '',
        isValidLastName: true
      })
    } else {
      this.setState({
        isValidLastName: false
      })
    }
  }

  validateOrganization = (input) => {
    if (input === '') {
      this.setState({
        organizationError: 'Company is required',
        isValidOrganization: false
      })
    } else if (input) {
      this.setState({
        organizationError: '',
        isValidOrganization: true
      })
    } else {
      this.setState({
        isValidOrganization: false
      })
    }
  }

  createSession = (account) => {
    fetch(this.getAppUrlForPath('/internal/account/login'), {
      method: 'PUT',
      credentials: 'include',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(account)
    })
      .catch(() => {
        // if there's an error here they've already created an account, so there's not much to do except take them to the app
        this.redirectToQuickstart()
      })
      .then((response) => {
        if (response && response.ok) {
          this.redirectToQuickstart()
        } else {
          response &&
            response.json().then((error) => {
              this.setState({
                formError: error && error.message
              })
            })
        }
      })
  }

  redirectToQuickstart = () => {
    window.location = this.getAppUrlForPath('/quickstart')
  }

  getAppUrlForPath = (path) => `${this.props.appUrl}${path}`

  createAccount = () => {
    const { username, firstName, lastName, organization, password, captcha, customReferer } = this.state

    const account = {
      username,
      firstName,
      lastName,
      organization,
      password,
      customReferer
    }

    if (captcha) {
      account.captcha = captcha
    }

    fetch(this.getAppUrlForPath('/internal/account/signup'), {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(account)
    })
      .catch(() => {
        this.setState({
          formError: 'We ran into problems creating your account. Please try again later.'
        })
        recaptchaRef.current.reset()
      })
      .then((response) => {
        if (response && response.ok) {
          bingEvent('Trial')

          googleTrackingTag('zZhKCNepxrQBEI-g9skD')

          qpGenLead()

          this.createSession(account)
        } else {
          response &&
            response.json().then((error) => {
              this.setState({
                formError: error && error.message
              })
              recaptchaRef.current.reset()
            })
        }
      })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    recaptchaRef.current.execute()
  }
}

const SignupComponent = ({ ...props }) => {
  const query = graphql`
    query SignupQuery {
      site {
        siteMetadata {
          params {
            appUrl
            googleCaptchaSiteKey
          }
        }
      }
    }
  `
  const data = useStaticQuery(query)

  return (
    <Signup
      appUrl={data.site.siteMetadata.params.appUrl}
      googleCaptchaSiteKey={data.site.siteMetadata.params.googleCaptchaSiteKey}
      {...props}
    />
  )
}

export default SignupComponent
